import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GLOBAL } from 'src/app/app.globals';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { ApiCallService } from 'src/app/service/api-call.service';

@Component({
  selector: 'app-edit-salary-wage-master',
  templateUrl: './edit-salary-wage-master.component.html',
  styleUrls: ['./edit-salary-wage-master.component.css']
})
export class EditSalaryWageMasterComponent implements OnInit {

  @Input() skillCode: any
  @Input() selectedData: any
  @Input() editRowData: any
  @Input() minimumWageList: any
  @Input() editContractorData: any

  selectedMinimumWage: any
  constructor(
    public activeModal: NgbActiveModal,
    public apiCall: ApiCallService,
    private logHelperService: LogHelperService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.selectedData.forEach(items => {
      // items.ApplicableDateFormatted = items.ApplicableDate.split('T')[0]
      items.setAmount = items.setAmount == null || items.setAmount == undefined || items.setAmount == "" ? 0 : items.setAmount
    })
    this.selectedMinimumWages = this.selectedData[0].MinWageMasterID
  }

  onChangeAmount(data, entry, skillCode) {
    if (entry.IsMinWageConfigValue === 1) {
      let totalSetAmount = 0;

      for (let items of skillCode) {
        if (items.Component_Code === -124) {
          break;
        }
        totalSetAmount += items.setAmount ? Number(items.setAmount) : 0;
      }

      for (let items of skillCode) {
        if (items.Component_Code === -124) {
          items.setAmount = totalSetAmount;
          break;
        }
      }
    }
  }

  selectedMinimumWages: any;
  onMinimumWageChange(event: any) {
    this.selectedMinimumWages = event;
    this.minimumWageList.forEach((items) => {
      if (items.ID == event) {
        let reqObj = {
          ContractorVendor_Code: this.editContractorData.ContractorVendor_Code,
          Plant_Code: items.Plant_Code,
          State_Code: items.State_Code,
          MiniWageCriteriaCompanyID: event,
          Action: 0,
          RequireType: 0,
          Skill_Code: this.selectedData[0].Skill_Code,
          RequestedUserId: GLOBAL.USER_ID

        }
        this.apiCall.checkMinimumWageEntry(reqObj).subscribe((res: any) => {
          if (res[0].Msg === "Exist") {
            this.logHelperService.logError({
              message: `Selected Minimum Wage is already exist. Please select another Minimum Wage`,
            });
            this.selectedMinimumWages = null;
            this.cdr.detectChanges();
            return;
          }

          if (event != null) {
            this.selectedData.forEach(result => {
              result.ApplicableDateFormatted = items.ApplicableDate.split('T')[0]
            })
          }
        });
      }
    });

    if (event == null) {
      this.selectedData.forEach(result => {
        result.ApplicableDateFormatted = null
      })
    }
  }

  onDropdownChange(data) {
    const skillItems = this.selectedData;
    if (!skillItems) return;
    const has114WithZeroAmount = skillItems.some(item => item.Component_Code === 114 && item.Amount == 0);
    skillItems.forEach(item => {
      if (item.Component_Code === 115) {
        item.isReadOnly = has114WithZeroAmount;
      }
    });
  }

  // selectAllRows(field, index) {
  //   this.selectedData.forEach(items => {
  //     items.ApplicableDateFormatted = index.ApplicableDateFormatted
  //   })
  // }
  // fillAllRows(field, index) {
  //   this.selectedData.forEach(items => {
  //     if (items.ApplicableDateFormatted == null) {
  //       items.ApplicableDateFormatted = index.ApplicableDateFormatted
  //     }
  //   })
  // }

  formatDate(dateStr: string): string {
    let dateObj = new Date(dateStr);
    let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    let day = dateObj.getDate().toString().padStart(2, '0');
    let year = dateObj.getFullYear();
    return `${month}/${day}/${year}`;
  }

  formatDateBeforeDate(dateStr: string): string {
    let dateObj = new Date(dateStr);
    dateObj.setDate(dateObj.getDate() - 1);
    let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    let day = dateObj.getDate().toString().padStart(2, '0');
    let year = dateObj.getFullYear();

    return `${month}/${day}/${year}`;
  }

  saveAllDataButton() {
    const hasInvalidDate = this.selectedData.some(items => items.ApplicableDateFormatted === null && items.Component_Code != 114 || items.ApplicableDateFormatted === null && items.Component_Code != 115 || items.ApplicableDateFormatted === "" && items.Component_Code != 114 || items.ApplicableDateFormatted === "" && items.Component_Code != 115);

    if (hasInvalidDate) {
      this.logHelperService.logError({
        message: `Effective date is required. Please fill up all dates.`,
      });
      return;
    }

    if (this.selectedMinimumWage == null || this.selectedMinimumWage == undefined || this.selectedMinimumWage == "") {
      this.logHelperService.logError({
        message: `Please select any minimum wage`,
      });
      return;
    }

    const invalidItems = this.selectedData.filter(items =>
      Number(items.setAmount) < Number(items.Amount) && items.Component_Code != 114 && items.Component_Code != 115
    );

    if (invalidItems.length > 0) {
      const invalidFields = invalidItems.map(item =>
        `Skill Code: ${item.Skill_Code}, Component Code: ${item.Component_Code}, Set Amount: ${item.setAmount}, Master Amount: ${item.Amount}`
      ).join('\n');

      this.logHelperService.logError({
        message: `Per Day Value cannot be less than the Master Value. Please correct it.\n${invalidFields}`,
      });

      return;
    }

    const selectedEntriesMap = {};
    const uniqueKey = `AF02D3CA-051A-4892-9A17-521D1FCA373F`;

    selectedEntriesMap[uniqueKey] = [];
    this.selectedData.forEach((entry) => {
      if (entry.Component_Code !== -124) {
        selectedEntriesMap[uniqueKey].push({
          ID: null,
          ContractorVendor_Code: this.editContractorData.ContractorVendor_Code,
          MinWageMasterID: entry.MinWageMasterID,
          SubContractorVendor_Code: null,
          Company_Code: entry.Company_Code,
          Plant_Code: entry.Plant_Code,
          State_Code: entry.State_Code,
          Skill_Code: entry.Skill_Code,
          AreaMIL_Code: entry.AreaMIL_Code,
          ZoneMIL_Code: entry.ZoneMIL_Code,
          QualificationMIL_Code: entry.QualificationMIL_Code,
          GradeMIL_Code: entry.GradeMIL_Code,
          GenderMIL_Code: null,
          CategoryMIL_Code: entry.CategoryMIL_Code,
          SubCategoryMIL_Code: entry.SubCategoryMIL_Code,
          Component_Code: entry.Component_Code,
          IsFoodInclude: entry.IsFoodInclude,
          PerDayValue: (() => {
            if (entry.Component_Code === 114 || entry.Component_Code === 115) {
              if (entry.Component_Code === 115 && this.selectedData.some(e => e.Component_Code === 114 && e.Amount === 0)) {
                return 0;
              }
              return entry.Amount;
            }
            return entry.setAmount == null || entry.setAmount == "" ? 0 : entry.setAmount;
          })(),

          // PerMonthValue: entry.MonthlyAmount,
          ApplicableDate: this.formatDate(entry.ApplicableDateFormatted),
          // ValiduptoDate: null,
          CreatedBy: GLOBAL.USER_ID,
          Modifiedby: GLOBAL.USER_ID,
          IsActive: 1,
          IsDeleted: 0,
          MiniWageCriteriaCompanyID: this.selectedMinimumWage
        });
      }
    });

    const selectedEntriesMap1 = {};
    const uniqueKey1 = `AF02D3CA-051A-4892-9A17-521D1FCA373F`;

    selectedEntriesMap1[uniqueKey1] = [];
    this.editRowData.forEach((entry) => {
      if (entry.Component_Code !== -124) {
        selectedEntriesMap1[uniqueKey1].push({
          ID: {
            OldValue: entry.ID,
            NewValue: entry.ID
          },
          IsActive: {
            OldValue: 1,
            NewValue: 0
          },
          ValiduptoDate: {
            OldValue: this.formatDateBeforeDate(entry.ApplicableDate),
            NewValue: this.formatDateBeforeDate(entry.ApplicableDate),
          }
        });
      }
    })

    this.apiCall.apiCommonInsertUpdate(selectedEntriesMap1).subscribe((res: any) => {
      this.activeModal.close();
    });

    this.apiCall.apiCommonInsertUpdate(selectedEntriesMap).subscribe((res: any) => {
      const key = Object.keys(res)[0];
      const ids = res[key].map(item => item.ID);
    });
  }
}
